import { BaseElement } from 'base';
import { purchaseRequest } from 'purchase-request';

const STICKY_TAG = 'sticky-cta';

class ProductSticky extends BaseElement {
  #requests = new Set();

  onConnect() {
    this.#requests = new Set();
    this.cleanup(() => this.#cancelAll());
    this.#bind();
  }

  async #bind() {
    await customElements.whenDefined(STICKY_TAG);
    if (!this.isConnected) return;
    this.q(STICKY_TAG)?.run(() => this.#purchase());
  }

  async #purchase() {
    const request = purchaseRequest.send(this.dataset.sectionId);
    this.#requests.add(request);
    const outcome = await request.result;
    this.#requests.delete(request);

    switch (outcome) {
      case 'unanswered':
        console.error(
          '[product-sticky] no product form answered the purchase request:',
          this.dataset.sectionId
        );
        break;
      case 'timeout':
        console.error(
          '[product-sticky] purchase request timed out:',
          request.id
        );
        throw new Error('[product-sticky] purchase request timed out');
      case 'failed':
        throw new Error('[product-sticky] add to cart failed');
    }
  }

  #cancelAll() {
    [...this.#requests].forEach(request => request.cancel());
  }
}

if (!customElements.get('product-sticky'))
  customElements.define('product-sticky', ProductSticky);
